import isIEbrowser from '../../../resources/scripts/helpers/is-IE';
import BackgroundVideo from '../../../resources/scripts/helpers/background-video';

class BrixGrid {
  static init(...parameters) {
    return new BrixGrid(...parameters);
  }

  constructor(container) {
    this.container = container;
    if (container) {
      this.animationHasRun = false;
      this.poster = container.querySelector('.image.-grid');
      this.video = container.querySelector('.video.-grid');
      this.paused = true;
      this.content = container.querySelector('.content');
      const IE = isIEbrowser();
      this.brixBlocks = container.querySelectorAll('.brix-block');

      if (IE) {
        for (let i = 0; i < this.brixBlocks.length; i += 1) {
          this.brixBlocks[i].classList.add('-IE');
        }
      }

      //  Animation options
      const options = {
        root: null,
        rootMargin: '0px',
        threshold: 0,
      };

      const callback = (event) => {
        if (event[0].isIntersecting && !this.animationHasRun) {
          if (this.content) {
            this.content.classList.add('-finished');
            this.animationHasRun = true;
          }
        }
      };

      if (!IE) {
        if (this.container && this.content) {
          this.content.classList.add('-transition');
          const observer = new IntersectionObserver(callback, options);
          observer.observe(this.container);
        }
      }

      if (container) {
        const backgroundVideoWrapper = document.querySelector(`#${container.id} > .background > .video`);

        if (backgroundVideoWrapper) {
          BackgroundVideo.init(container);
        }
      }
    }
  }
}

// Register class
if (window.brix && window.brix.registerBlock) {
  window.brix.registerBlock('brix-grid', BrixGrid.init);
}
